import styled from 'styled-components';

const StyledCountrySelectorPositioner = styled.div`
  left: 0;
  position: absolute;
  top: 50%;
  width: 100%;
  margin-top: -11px;
`;

export default StyledCountrySelectorPositioner;
